import { GetRewardsConfigResponse } from './types';

export const MOCK_REWARDS_CONFIG: GetRewardsConfigResponse = {
  programCode: '26FOR26',
  track: 'TRACK_1',
  phase: {
    number: 1,
    code: 'ACT1',
    name: 'Act 1',
    start: '2026-01-01T00:00:00Z',
    end: '2026-12-31T23:59:59Z',
    attemptType: 'SPIN',
  },
  config: {
    program: { code: '26FOR26', entry_threshold: 5 },
    tracks: {
      TRACK1: {
        type: 'PHASED',
        phases: [
          {
            code: 'ACT1',
            attempt_type: 'SPIN',
            display_version: 'spin-wheel-v1',
            outcomes: [
              {
                code: 'LARGE',
                weight: 1,
                prize_amount: 350,
                is_win: true,
                max_wins: 5,
                downgrade_to: 'MEDIUM',
                review: true,
              },
              {
                code: 'MEDIUM',
                weight: 5,
                prize_amount: 100,
                is_win: true,
                max_wins: 50,
                downgrade_to: 'SMALL',
              },
              {
                code: 'SMALL',
                weight: 25,
                prize_amount: 40,
                is_win: true,
                max_wins: 500,
                downgrade_to: 'CONSOLATION',
              },
              {
                code: 'CONSOLATION',
                weight: 69,
                prize_amount: null,
                is_win: false,
                grants_entry_in_phase: 'ACT2',
              },
            ],
          },
          {
            code: 'ACT2',
            attempt_type: 'RAFFLE_ENTRY',
            display_version: 'raffle-v1',
            drawing: {
              review_scope: 'ALL',
              prizes: [
                {
                  code: 'LARGE',
                  win_rate: 0.01,
                  prize_amount: 500,
                  max_wins: 1,
                  review: true,
                },
              ],
            },
          },
          // ACT3 — Scratch Off (mirrors prime V000061 L42-52)
          {
            code: 'ACT3',
            attempt_type: 'SCRATCH_OFF',
            display_version: 'scratch-off-v1',
            outcomes: [
              {
                code: 'SUPER',
                weight: 0.1,
                prize_amount: 2500,
                is_win: true,
                max_wins: 1,
                review: true,
              },
              {
                code: 'LARGE',
                weight: 1,
                prize_amount: 1000,
                is_win: true,
                max_wins: 5,
                review: true,
              },
              {
                code: 'MEDIUM',
                weight: 5,
                prize_amount: 200,
                is_win: true,
                max_wins: 50,
              },
              {
                code: 'SMALL',
                weight: 25,
                prize_amount: 100,
                is_win: true,
                max_wins: 500,
              },
              {
                code: 'NONE',
                weight: 68.9,
                prize_amount: null,
                is_win: false,
              },
            ],
          },
        ],
      },
      TRACK2: {
        top_producer_eval: {
          prize_per_phase: {
            ACT1: 150,
            ACT2: 175,
            ACT3: 200,
          },
          // Note: prod config does NOT have start/end here — program window comes from
          // the grand-prize-status endpoint (programStart/programEnd).
        },
        tier_eval: {
          tiers: [
            { code: 'GOLD', act_floor: 25 },
            { code: 'SILVER', act_floor: 15 },
            { code: 'BRONZE', act_floor: 5 },
          ],
        },
      },
    },
  },
};
